export const useIsMobile = () => /mobi/i.test(navigator.userAgent);
